export const accessLogMigrations = [
  {
    id: '045_user_access_logs',
    sql: `
      CREATE TABLE IF NOT EXISTS user_access_logs (
        id BIGSERIAL PRIMARY KEY,
        user_id UUID NOT NULL REFERENCES users(id) ON DELETE CASCADE,
        ip_encrypted TEXT NOT NULL,
        ip_hash TEXT NOT NULL,
        ip_version TEXT NOT NULL,
        is_private BOOLEAN NOT NULL DEFAULT FALSE,
        country TEXT,
        region TEXT,
        city TEXT,
        user_agent TEXT NOT NULL DEFAULT '',
        device_type TEXT NOT NULL DEFAULT 'unknown',
        browser TEXT NOT NULL DEFAULT 'unknown',
        operating_system TEXT NOT NULL DEFAULT 'unknown',
        created_at TIMESTAMPTZ NOT NULL DEFAULT NOW()
      );
      CREATE INDEX IF NOT EXISTS user_access_logs_user_time_idx
        ON user_access_logs (user_id, created_at DESC);
      CREATE INDEX IF NOT EXISTS user_access_logs_hash_idx
        ON user_access_logs (ip_hash, created_at DESC);
    `,
  },
] as const;
